// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteMap {
  min-height: 50vh;
  height: 100%;
}
.RouteMap > .card {
  padding: 1.5rem 1rem;
}
.RouteMap > .card .card-body {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.RouteMap > .card .card-body .MapDisplay {
  height: 100%;
}
.RouteMap > .card .card-body .map-content {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  align-items: center;
  background: #f8f9fa;
  border-radius: 8px;
}
.RouteMap > .card .card-body .map-content .map-placeholder {
  text-align: center;
  max-width: 400px;
}
.RouteMap > .card .card-body .map-content .map-placeholder .map-icon-large {
  margin-bottom: 20px;
}
.RouteMap > .card .card-body .map-content .map-placeholder .map-icon-large i {
  font-size: 48px;
  color: #6c757d;
  background: #e9ecef;
  padding: 24px;
  border-radius: 50%;
  width: 96px;
  height: 96px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.RouteMap > .card .card-body .map-content .map-placeholder .ready-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}
.RouteMap > .card .card-body .map-content .map-placeholder .ready-description {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.4;
}
.RouteMap > .card .card-body .map-content .map-placeholder .isolated-notice {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 8px 12px;
  text-align: left;
  font-size: 12px;
  max-width: 320px;
  margin: 0 auto;
}
.RouteMap > .card .card-body .map-content .map-placeholder .isolated-notice .warning-icon {
  font-size: 12px;
  color: #856404;
  margin-top: 1px;
  flex-shrink: 0;
}
.RouteMap > .card .card-body .map-content .map-placeholder .isolated-notice .notice-text {
  font-size: 12px;
  color: #856404;
  line-height: 1.3;
}
.RouteMap > .card .card-header {
  padding: 0;
}
.RouteMap > .card .card-header .title-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}
.RouteMap > .card .card-header .title-with-icon .map-icon {
  font-size: 18px;
  color: #333;
}
.RouteMap > .card .card-header .title-with-icon .title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.RouteMap > .card .card-header .title-with-icon .info-icon {
  font-size: 14px;
  color: #666;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/RouteMap/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;AACF;AAAE;EACE,oBAAA;AAEJ;AADI;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAGN;AADM;EACE,YAAA;AAGR;AAAM;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAER;AAAQ;EACE,kBAAA;EACA,gBAAA;AAEV;AAAU;EACE,mBAAA;AAEZ;AAAY;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAEd;AAEU;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAAZ;AAGU;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AADZ;AAIU;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFZ;AAIY;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAFd;AAKY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAHd;AAUI;EACE,UAAA;AARN;AASM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAPR;AASQ;EACE,eAAA;EACA,WAAA;AAPV;AAUQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AARV;AAWQ;EACE,eAAA;EACA,WAAA;EACA,eAAA;AATV","sourcesContent":[".RouteMap {\n  min-height: 50vh;\n  height: 100%;\n  > .card {\n    padding: 1.5rem 1rem;\n    .card-body {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n\n      .MapDisplay {\n        height: 100%;\n      }\n\n      .map-content {\n        flex: 1;\n        display: flex;\n        align-items: flex-start;\n        justify-content: center;\n        align-items: center;\n        background: #f8f9fa;\n        border-radius: 8px;\n\n        .map-placeholder {\n          text-align: center;\n          max-width: 400px;\n\n          .map-icon-large {\n            margin-bottom: 20px;\n\n            i {\n              font-size: 48px;\n              color: #6c757d;\n              background: #e9ecef;\n              padding: 24px;\n              border-radius: 50%;\n              width: 96px;\n              height: 96px;\n              display: inline-flex;\n              align-items: center;\n              justify-content: center;\n            }\n          }\n\n          .ready-title {\n            font-size: 18px;\n            font-weight: 600;\n            color: #333;\n            margin-bottom: 8px;\n          }\n\n          .ready-description {\n            font-size: 14px;\n            color: #666;\n            margin-bottom: 24px;\n            line-height: 1.4;\n          }\n\n          .isolated-notice {\n            display: flex;\n            align-items: flex-start;\n            gap: 6px;\n            background: #fff3cd;\n            border: 1px solid #ffeaa7;\n            border-radius: 4px;\n            padding: 8px 12px;\n            text-align: left;\n            font-size: 12px;\n            max-width: 320px;\n            margin: 0 auto;\n\n            .warning-icon {\n              font-size: 12px;\n              color: #856404;\n              margin-top: 1px;\n              flex-shrink: 0;\n            }\n\n            .notice-text {\n              font-size: 12px;\n              color: #856404;\n              line-height: 1.3;\n            }\n          }\n        }\n      }\n    }\n\n    .card-header {\n      padding: 0;\n      .title-with-icon {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .map-icon {\n          font-size: 18px;\n          color: #333;\n        }\n\n        .title {\n          font-size: 18px;\n          font-weight: 600;\n          color: #333;\n        }\n\n        .info-icon {\n          font-size: 14px;\n          color: #666;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
